import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { onAuthChange, listenTeam, setPlayerLocation } from '../firebase';

export default function LocationWatcher(){
  const [user, setUser] = useState(null);
  const [team, setTeam] = useState(null);
  const location = useLocation();

  useEffect(()=>{
    const unsub = onAuthChange(u => setUser(u));
    return unsub;
  }, []);

  // Track teamId from localStorage and refresh when route changes (so updates done by PlayerCreateTeam take effect)
  useEffect(()=>{
    const teamId = typeof window !== 'undefined' ? localStorage.getItem('teamId') : null;
    if (!teamId) {
      setTeam(null);
      return;
    }
    const unsub = listenTeam(teamId, setTeam);
    return () => unsub && unsub();
  }, [location]);

  useEffect(()=>{
    if (!user) return;
    const teamId = typeof window !== 'undefined' ? localStorage.getItem('teamId') : null;
    if (!teamId) return;
    if (!navigator.geolocation) return;

    let active = true;
    const watchId = navigator.geolocation.watchPosition(async (pos) => {
      if (!active) return;
      const lat = pos.coords.latitude;
      const lng = pos.coords.longitude;
      try {
        const displayName = team && team.members && team.members[user.uid] ? team.members[user.uid] : undefined;
        await setPlayerLocation(user.uid, teamId, lat, lng, displayName);
      } catch (err) {
        console.warn('LocationWatcher failed to send location', err);
      }
    }, (err) => {
      // ignore errors here; UI components may show permission issues
      console.warn('Geolocation watch error', err);
    }, { enableHighAccuracy: false, maximumAge: 5000, timeout: 10000 });

    return () => { active = false; navigator.geolocation.clearWatch(watchId); };
  }, [user, team, location]);

  return null;
}
